import { render } from "./ProductBrandComponent.vue?vue&type=template&id=aba85002"
import script from "./ProductBrandComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductBrand/ProductBrandComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aba85002"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aba85002', __exports__)) {
    api.reload('aba85002', __exports__)
  }
  
  module.hot.accept("./ProductBrandComponent.vue?vue&type=template&id=aba85002", () => {
    api.rerender('aba85002', render)
  })

}


export default __exports__